import { useQuery } from '@tanstack/react-query';
import { SUPABASE_URL } from '@/integrations/supabase/client';

const PUBLISHABLE_KEY = (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '').trim();

/**
 * True once Google is switched on in Supabase Auth (public /auth/v1/settings),
 * so the Google buttons never lead to GoTrue's "provider is not enabled" page
 * and appear by themselves when the provider is turned on.
 */
export function useGoogleSignInEnabled(): boolean {
  const { data } = useQuery({
    queryKey: ['auth-settings'],
    queryFn: async () => {
      const res = await fetch(`${SUPABASE_URL}/auth/v1/settings`, { headers: { apikey: PUBLISHABLE_KEY } });
      if (!res.ok) throw new Error(`Auth settings returned ${res.status}`);
      return (await res.json()) as { external?: Record<string, boolean> };
    },
    staleTime: 5 * 60_000,
    retry: 1,
  });
  return data?.external?.google === true;
}
